const zh = {
  site: {
    name: '乐鱼体育新闻资讯站',
    tagline: '最新体育资讯一站掌握',
    description: '乐鱼体育新闻资讯站，为您提供最新、最全的体育新闻资讯，涵盖足球、篮球、综合格斗等热门赛事动态，实时比分、赛事分析、球员动态一网打尽，是体育爱好者的首选资讯平台。',
  },
  nav: {
    home: '首页',
    football: '足球',
    basketball: '篮球',
    mma: '综合格斗',
    tennis: '网球',
    esports: '电竞',
    racing: '赛车',
    about: '关于我们',
    search: '搜索资讯...',
  },
  home: {
    heroTitle: '最新体育资讯一站掌握',
    heroSubtitle: '足球、篮球、综合格斗、网球、电竞、赛车 — 全方位覆盖热门赛事，实时比分、深度分析、球员动态尽在乐鱼体育',
    hotNews: '热点新闻',
    featuredNews: '头条推荐',
    latestNews: '最新资讯',
    categoryNav: '赛事分类',
    viewAll: '查看全部',
    readMore: '阅读全文',
    views: '阅读',
    readCount: '次阅读',
  },
  category: {
    title: '分类',
    breadcrumbHome: '首页',
    noArticles: '暂无相关文章',
  },
  article: {
    breadcrumbHome: '首页',
    author: '作者',
    publishDate: '发布时间',
    views: '阅读量',
    tags: '标签',
    relatedArticles: '相关推荐',
    backToList: '返回列表',
  },
  about: {
    title: '关于我们',
    breadcrumbHome: '首页',
    brandIntro: '品牌介绍',
    brandIntroContent: '乐鱼体育新闻资讯站成立于2020年，是国内领先的综合性体育资讯平台。我们致力于为体育爱好者提供全方位、高质量的体育新闻资讯服务，涵盖足球、篮球、综合格斗、网球、电竞、赛车等热门体育项目。',
    reputation: '平台信誉',
    reputationContent1: '日均访问量超过500万，月活跃用户超过2000万',
    reputationContent2: '与超过50家国内外体育机构保持官方合作关系',
    reputationContent3: '拥有200+专业体育编辑与记者团队',
    reputationContent4: '7x24小时全天候实时资讯更新',
    reputationContent5: '连续三年获得"中国最佳体育资讯平台"称号',
    contact: '联系我们',
    contactEmail: '电子邮箱',
    contactPhone: '联系电话',
    contactAddress: '公司地址',
    contactAddressValue: '北京市朝阳区体育中心路88号乐鱼大厦',
    contactEmailValue: 'contact@leyusports.com',
    contactPhoneValue: '400-888-9999',
  },
  footer: {
    copyright: '© 2026 乐鱼体育新闻资讯站 版权所有',
    about: '关于我们',
    privacy: '隐私政策',
    terms: '服务条款',
    contact: '联系我们',
    quickLinks: '快速链接',
    categories: '热门分类',
    followUs: '关注我们',
  },
  common: {
    loading: '加载中...',
    error: '加载失败，请重试',
    retry: '重试',
  },
};

export default zh;